//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The mandarin css vars
*
* 
*  * COLOR_BASE_GREY_LIGHT value: --xm-color-base-grey-light - color: the base light grey 
*  * COLOR_BASE_GREY_MEDIUM value: --xm-color-base-grey-medium - color: the base medium grey 
*  * COLOR_BASE_GREY_DARK value: --xm-color-base-grey-dark - color: the base dark grey 
*  * COLOR_BASE_GREY_DARKER value: --xm-color-base-grey-darker - color: the base grey 
*  * COLOR_BASE_GREY_DARKEST value: --xm-color-base-grey-darkest - color: the base grey 
*  * COLOR_BASE_WHITE value: --xm-color-base-white - color: the base white 
*  * COLOR_BASE_BLACK value: --xm-color-base-black - color: the base black 
*  * COLOR_BASE_ORANGE_LIGHT value: --xm-color-base-orange-light - color: the base light orange 
*  * COLOR_BASE_ORANGE_PALE value: --xm-color-base-orange-pale - color: the base pale orange 
*  * COLOR_BASE_ORANGE_MEDIUM value: --xm-color-base-orange-medium - color: the base medium orange 
*  * COLOR_BASE_ORANGE_DARK value: --xm-color-base-orange-dark - color: the base dark orange 
*  * COLOR_BASE_ORANGE_DARKER value: --xm-color-base-orange-darker - color: the base darker orange 
*  * COLOR_BASE_ORANGE_DARKEST value: --xm-color-base-orange-darkest - color: the base darkest orange 
*  * COLOR_BASE_BLUE_LIGHT value: --xm-color-base-blue-light - color: the base light blue 
*  * COLOR_BASE_BLUE_MEDIUM value: --xm-color-base-blue-medium - color: the base dark blue 
*  * COLOR_BASE_BLUE_DARK value: --xm-color-base-blue-dark - color: the base dark blue 
*  * COLOR_BASE_GREEN_LIGHT value: --xm-color-base-green-light - color: the base light green 
*  * COLOR_BASE_GREEN_DARK value: --xm-color-base-green-dark - color: the base dark green 
*  * COLOR_BASE_YELLOW_GREEN value: --xm-color-base-yellow-green - color: the base yellow green 
*  * COLOR_BASE_YELLOW_DARK value: --xm-color-base-yellow-dark - color: the base dark yellow 
*  * COLOR_BASE_RED value: --xm-color-base-red - color: the base red 
*  * COLOR_BASE_ROSE value: --xm-color-base-rose - color: the base rose 
*  * COLOR_BASE_PINK value: --xm-color-base-pink - color: the base rose 
*  * COLOR_BASE_PURPLE value: --xm-color-base-purple - color: the base rose 
*  * COLOR_BACKGROUND_BASE value: --xm-color-background-base - color: the base bg 
*  * COLOR_FOREGROUND_BASE value: --xm-color-foreground-base - color: the base fg 
*  * COLOR_ICON_JANUARY_LIGHT value: --xm-color-icon-january-light - color: the light 01 
*  * COLOR_ICON_JANUARY_DARK value: --xm-color-icon-january-dark - color: the dark 01 
*  * COLOR_ICON_JANUARY_GRADIENT_START value: --xm-color-icon-january-gradient-start - color: the gradient start 01 
*  * COLOR_ICON_JANUARY_GRADIENT_END value: --xm-color-icon-january-gradient-end - color: the gradient end 01 
*  * COLOR_ICON_FEBRUARY_LIGHT value: --xm-color-icon-february-light - color: the light 02 
*  * COLOR_ICON_FEBRUARY_DARK value: --xm-color-icon-february-dark - color: the dark 02 
*  * COLOR_ICON_FEBRUARY_GRADIENT_START value: --xm-color-icon-february-gradient-start - color: the gradient start 02 
*  * COLOR_ICON_FEBRUARY_GRADIENT_END value: --xm-color-icon-february-gradient-end - color: the gradient end 02 
*  * COLOR_ICON_MARCH_LIGHT value: --xm-color-icon-march-light - color: the light 03 
*  * COLOR_ICON_MARCH_DARK value: --xm-color-icon-march-dark - color: the dark 03 
*  * COLOR_ICON_MARCH_GRADIENT_START value: --xm-color-icon-march-gradient-start - color: the gradient start 03 
*  * COLOR_ICON_MARCH_GRADIENT_END value: --xm-color-icon-march-gradient-end - color: the gradient end 03 
*  * COLOR_ICON_APRIL_LIGHT value: --xm-color-icon-april-light - color: the light 04 
*  * COLOR_ICON_APRIL_DARK value: --xm-color-icon-april-dark - color: the dark 04 
*  * COLOR_ICON_APRIL_GRADIENT_START value: --xm-color-icon-april-gradient-start - color: the gradient start 04 
*  * COLOR_ICON_APRIL_GRADIENT_END value: --xm-color-icon-april-gradient-end - color: the gradient end 04 
*  * COLOR_ICON_MAY_LIGHT value: --xm-color-icon-may-light - color: the light 05 
*  * COLOR_ICON_MAY_DARK value: --xm-color-icon-may-dark - color: the dark 05 
*  * COLOR_ICON_MAY_GRADIENT_START value: --xm-color-icon-may-gradient-start - color: the gradient start 05 
*  * COLOR_ICON_MAY_GRADIENT_END value: --xm-color-icon-may-gradient-end - color: the gradient end 05 
*  * COLOR_ICON_JUNE_LIGHT value: --xm-color-icon-june-light - color: the light 06 
*  * COLOR_ICON_JUNE_DARK value: --xm-color-icon-june-dark - color: the dark 06 
*  * COLOR_ICON_JUNE_GRADIENT_START value: --xm-color-icon-june-gradient-start - color: the gradient start 06 
*  * COLOR_ICON_JUNE_GRADIENT_END value: --xm-color-icon-june-gradient-end - color: the gradient end 06 
*  * COLOR_ICON_JULY_LIGHT value: --xm-color-icon-july-light - color: the light 07 
*  * COLOR_ICON_JULY_DARK value: --xm-color-icon-july-dark - color: the dark 07 
*  * COLOR_ICON_JULY_GRADIENT_START value: --xm-color-icon-july-gradient-start - color: the gradient start 07 
*  * COLOR_ICON_JULY_GRADIENT_END value: --xm-color-icon-july-gradient-end - color: the gradient end 07 
*  * COLOR_ICON_AUGUST_LIGHT value: --xm-color-icon-august-light - color: the light 08 
*  * COLOR_ICON_AUGUST_DARK value: --xm-color-icon-august-dark - color: the dark 08 
*  * COLOR_ICON_AUGUST_GRADIENT_START value: --xm-color-icon-august-gradient-start - color: the gradient start 08 
*  * COLOR_ICON_AUGUST_GRADIENT_END value: --xm-color-icon-august-gradient-end - color: the gradient end 08 
*  * COLOR_ICON_SEPTEMBER_LIGHT value: --xm-color-icon-september-light - color: the light 09 
*  * COLOR_ICON_SEPTEMBER_DARK value: --xm-color-icon-september-dark - color: the dark 09 
*  * COLOR_ICON_SEPTEMBER_GRADIENT_START value: --xm-color-icon-september-gradient-start - color: the gradient start 09 
*  * COLOR_ICON_SEPTEMBER_GRADIENT_END value: --xm-color-icon-september-gradient-end - color: the gradient end 09 
*  * COLOR_ICON_OCTOBER_LIGHT value: --xm-color-icon-october-light - color: the light 10 
*  * COLOR_ICON_OCTOBER_DARK value: --xm-color-icon-october-dark - color: the dark 10 
*  * COLOR_ICON_OCTOBER_GRADIENT_START value: --xm-color-icon-october-gradient-start - color: the gradient start 10 
*  * COLOR_ICON_OCTOBER_GRADIENT_END value: --xm-color-icon-october-gradient-end - color: the gradient end 10 
*  * COLOR_ICON_NOVEMBER_LIGHT value: --xm-color-icon-november-light - color: the light 11 
*  * COLOR_ICON_NOVEMBER_DARK value: --xm-color-icon-november-dark - color: the dark 11 
*  * COLOR_ICON_NOVEMBER_GRADIENT_START value: --xm-color-icon-november-gradient-start - color: the gradient start 11 
*  * COLOR_ICON_NOVEMBER_GRADIENT_END value: --xm-color-icon-november-gradient-end - color: the gradient end 11 
*  * COLOR_ICON_DECEMBER_LIGHT value: --xm-color-icon-december-light - color: the light 12 
*  * COLOR_ICON_DECEMBER_DARK value: --xm-color-icon-december-dark - color: the dark 12 
*  * COLOR_ICON_DECEMBER_GRADIENT_START value: --xm-color-icon-december-gradient-start - color: the gradient start 12 
*  * COLOR_ICON_DECEMBER_GRADIENT_END value: --xm-color-icon-december-gradient-end - color: the gradient end 12 
*  * COLOR_FONT_BASE value: --xm-color-font-base - color: the base font color 
*  * COLOR_FONT_SECONDARY value: --xm-color-font-secondary - color: the 2nd font color 
*  * COLOR_FONT_TERTIARY value: --xm-color-font-tertiary - color: the 3rd font color 
*  * SIZE_FONT_SMALL value: --xm-size-font-small - fontSize: the small size of the font 
*  * SIZE_FONT_MEDIUM value: --xm-size-font-medium - fontSize: the medium size of the font 
*  * SIZE_FONT_LARGE value: --xm-size-font-large - fontSize: the large size of the font 
*  * SIZE_FONT_BASE value: --xm-size-font-base - fontSize: the base size of the font 
*/
@Serializable
enum class MandarinTokenVar(val value: kotlin.String) {

    @SerialName(value = "--xm-color-base-grey-light")
    COLOR_BASE_GREY_LIGHT("--xm-color-base-grey-light"),

    @SerialName(value = "--xm-color-base-grey-medium")
    COLOR_BASE_GREY_MEDIUM("--xm-color-base-grey-medium"),

    @SerialName(value = "--xm-color-base-grey-dark")
    COLOR_BASE_GREY_DARK("--xm-color-base-grey-dark"),

    @SerialName(value = "--xm-color-base-grey-darker")
    COLOR_BASE_GREY_DARKER("--xm-color-base-grey-darker"),

    @SerialName(value = "--xm-color-base-grey-darkest")
    COLOR_BASE_GREY_DARKEST("--xm-color-base-grey-darkest"),

    @SerialName(value = "--xm-color-base-white")
    COLOR_BASE_WHITE("--xm-color-base-white"),

    @SerialName(value = "--xm-color-base-black")
    COLOR_BASE_BLACK("--xm-color-base-black"),

    @SerialName(value = "--xm-color-base-orange-light")
    COLOR_BASE_ORANGE_LIGHT("--xm-color-base-orange-light"),

    @SerialName(value = "--xm-color-base-orange-pale")
    COLOR_BASE_ORANGE_PALE("--xm-color-base-orange-pale"),

    @SerialName(value = "--xm-color-base-orange-medium")
    COLOR_BASE_ORANGE_MEDIUM("--xm-color-base-orange-medium"),

    @SerialName(value = "--xm-color-base-orange-dark")
    COLOR_BASE_ORANGE_DARK("--xm-color-base-orange-dark"),

    @SerialName(value = "--xm-color-base-orange-darker")
    COLOR_BASE_ORANGE_DARKER("--xm-color-base-orange-darker"),

    @SerialName(value = "--xm-color-base-orange-darkest")
    COLOR_BASE_ORANGE_DARKEST("--xm-color-base-orange-darkest"),

    @SerialName(value = "--xm-color-base-blue-light")
    COLOR_BASE_BLUE_LIGHT("--xm-color-base-blue-light"),

    @SerialName(value = "--xm-color-base-blue-medium")
    COLOR_BASE_BLUE_MEDIUM("--xm-color-base-blue-medium"),

    @SerialName(value = "--xm-color-base-blue-dark")
    COLOR_BASE_BLUE_DARK("--xm-color-base-blue-dark"),

    @SerialName(value = "--xm-color-base-green-light")
    COLOR_BASE_GREEN_LIGHT("--xm-color-base-green-light"),

    @SerialName(value = "--xm-color-base-green-dark")
    COLOR_BASE_GREEN_DARK("--xm-color-base-green-dark"),

    @SerialName(value = "--xm-color-base-yellow-green")
    COLOR_BASE_YELLOW_GREEN("--xm-color-base-yellow-green"),

    @SerialName(value = "--xm-color-base-yellow-dark")
    COLOR_BASE_YELLOW_DARK("--xm-color-base-yellow-dark"),

    @SerialName(value = "--xm-color-base-red")
    COLOR_BASE_RED("--xm-color-base-red"),

    @SerialName(value = "--xm-color-base-rose")
    COLOR_BASE_ROSE("--xm-color-base-rose"),

    @SerialName(value = "--xm-color-base-pink")
    COLOR_BASE_PINK("--xm-color-base-pink"),

    @SerialName(value = "--xm-color-base-purple")
    COLOR_BASE_PURPLE("--xm-color-base-purple"),

    @SerialName(value = "--xm-color-background-base")
    COLOR_BACKGROUND_BASE("--xm-color-background-base"),

    @SerialName(value = "--xm-color-foreground-base")
    COLOR_FOREGROUND_BASE("--xm-color-foreground-base"),

    @SerialName(value = "--xm-color-icon-january-light")
    COLOR_ICON_JANUARY_LIGHT("--xm-color-icon-january-light"),

    @SerialName(value = "--xm-color-icon-january-dark")
    COLOR_ICON_JANUARY_DARK("--xm-color-icon-january-dark"),

    @SerialName(value = "--xm-color-icon-january-gradient-start")
    COLOR_ICON_JANUARY_GRADIENT_START("--xm-color-icon-january-gradient-start"),

    @SerialName(value = "--xm-color-icon-january-gradient-end")
    COLOR_ICON_JANUARY_GRADIENT_END("--xm-color-icon-january-gradient-end"),

    @SerialName(value = "--xm-color-icon-february-light")
    COLOR_ICON_FEBRUARY_LIGHT("--xm-color-icon-february-light"),

    @SerialName(value = "--xm-color-icon-february-dark")
    COLOR_ICON_FEBRUARY_DARK("--xm-color-icon-february-dark"),

    @SerialName(value = "--xm-color-icon-february-gradient-start")
    COLOR_ICON_FEBRUARY_GRADIENT_START("--xm-color-icon-february-gradient-start"),

    @SerialName(value = "--xm-color-icon-february-gradient-end")
    COLOR_ICON_FEBRUARY_GRADIENT_END("--xm-color-icon-february-gradient-end"),

    @SerialName(value = "--xm-color-icon-march-light")
    COLOR_ICON_MARCH_LIGHT("--xm-color-icon-march-light"),

    @SerialName(value = "--xm-color-icon-march-dark")
    COLOR_ICON_MARCH_DARK("--xm-color-icon-march-dark"),

    @SerialName(value = "--xm-color-icon-march-gradient-start")
    COLOR_ICON_MARCH_GRADIENT_START("--xm-color-icon-march-gradient-start"),

    @SerialName(value = "--xm-color-icon-march-gradient-end")
    COLOR_ICON_MARCH_GRADIENT_END("--xm-color-icon-march-gradient-end"),

    @SerialName(value = "--xm-color-icon-april-light")
    COLOR_ICON_APRIL_LIGHT("--xm-color-icon-april-light"),

    @SerialName(value = "--xm-color-icon-april-dark")
    COLOR_ICON_APRIL_DARK("--xm-color-icon-april-dark"),

    @SerialName(value = "--xm-color-icon-april-gradient-start")
    COLOR_ICON_APRIL_GRADIENT_START("--xm-color-icon-april-gradient-start"),

    @SerialName(value = "--xm-color-icon-april-gradient-end")
    COLOR_ICON_APRIL_GRADIENT_END("--xm-color-icon-april-gradient-end"),

    @SerialName(value = "--xm-color-icon-may-light")
    COLOR_ICON_MAY_LIGHT("--xm-color-icon-may-light"),

    @SerialName(value = "--xm-color-icon-may-dark")
    COLOR_ICON_MAY_DARK("--xm-color-icon-may-dark"),

    @SerialName(value = "--xm-color-icon-may-gradient-start")
    COLOR_ICON_MAY_GRADIENT_START("--xm-color-icon-may-gradient-start"),

    @SerialName(value = "--xm-color-icon-may-gradient-end")
    COLOR_ICON_MAY_GRADIENT_END("--xm-color-icon-may-gradient-end"),

    @SerialName(value = "--xm-color-icon-june-light")
    COLOR_ICON_JUNE_LIGHT("--xm-color-icon-june-light"),

    @SerialName(value = "--xm-color-icon-june-dark")
    COLOR_ICON_JUNE_DARK("--xm-color-icon-june-dark"),

    @SerialName(value = "--xm-color-icon-june-gradient-start")
    COLOR_ICON_JUNE_GRADIENT_START("--xm-color-icon-june-gradient-start"),

    @SerialName(value = "--xm-color-icon-june-gradient-end")
    COLOR_ICON_JUNE_GRADIENT_END("--xm-color-icon-june-gradient-end"),

    @SerialName(value = "--xm-color-icon-july-light")
    COLOR_ICON_JULY_LIGHT("--xm-color-icon-july-light"),

    @SerialName(value = "--xm-color-icon-july-dark")
    COLOR_ICON_JULY_DARK("--xm-color-icon-july-dark"),

    @SerialName(value = "--xm-color-icon-july-gradient-start")
    COLOR_ICON_JULY_GRADIENT_START("--xm-color-icon-july-gradient-start"),

    @SerialName(value = "--xm-color-icon-july-gradient-end")
    COLOR_ICON_JULY_GRADIENT_END("--xm-color-icon-july-gradient-end"),

    @SerialName(value = "--xm-color-icon-august-light")
    COLOR_ICON_AUGUST_LIGHT("--xm-color-icon-august-light"),

    @SerialName(value = "--xm-color-icon-august-dark")
    COLOR_ICON_AUGUST_DARK("--xm-color-icon-august-dark"),

    @SerialName(value = "--xm-color-icon-august-gradient-start")
    COLOR_ICON_AUGUST_GRADIENT_START("--xm-color-icon-august-gradient-start"),

    @SerialName(value = "--xm-color-icon-august-gradient-end")
    COLOR_ICON_AUGUST_GRADIENT_END("--xm-color-icon-august-gradient-end"),

    @SerialName(value = "--xm-color-icon-september-light")
    COLOR_ICON_SEPTEMBER_LIGHT("--xm-color-icon-september-light"),

    @SerialName(value = "--xm-color-icon-september-dark")
    COLOR_ICON_SEPTEMBER_DARK("--xm-color-icon-september-dark"),

    @SerialName(value = "--xm-color-icon-september-gradient-start")
    COLOR_ICON_SEPTEMBER_GRADIENT_START("--xm-color-icon-september-gradient-start"),

    @SerialName(value = "--xm-color-icon-september-gradient-end")
    COLOR_ICON_SEPTEMBER_GRADIENT_END("--xm-color-icon-september-gradient-end"),

    @SerialName(value = "--xm-color-icon-october-light")
    COLOR_ICON_OCTOBER_LIGHT("--xm-color-icon-october-light"),

    @SerialName(value = "--xm-color-icon-october-dark")
    COLOR_ICON_OCTOBER_DARK("--xm-color-icon-october-dark"),

    @SerialName(value = "--xm-color-icon-october-gradient-start")
    COLOR_ICON_OCTOBER_GRADIENT_START("--xm-color-icon-october-gradient-start"),

    @SerialName(value = "--xm-color-icon-october-gradient-end")
    COLOR_ICON_OCTOBER_GRADIENT_END("--xm-color-icon-october-gradient-end"),

    @SerialName(value = "--xm-color-icon-november-light")
    COLOR_ICON_NOVEMBER_LIGHT("--xm-color-icon-november-light"),

    @SerialName(value = "--xm-color-icon-november-dark")
    COLOR_ICON_NOVEMBER_DARK("--xm-color-icon-november-dark"),

    @SerialName(value = "--xm-color-icon-november-gradient-start")
    COLOR_ICON_NOVEMBER_GRADIENT_START("--xm-color-icon-november-gradient-start"),

    @SerialName(value = "--xm-color-icon-november-gradient-end")
    COLOR_ICON_NOVEMBER_GRADIENT_END("--xm-color-icon-november-gradient-end"),

    @SerialName(value = "--xm-color-icon-december-light")
    COLOR_ICON_DECEMBER_LIGHT("--xm-color-icon-december-light"),

    @SerialName(value = "--xm-color-icon-december-dark")
    COLOR_ICON_DECEMBER_DARK("--xm-color-icon-december-dark"),

    @SerialName(value = "--xm-color-icon-december-gradient-start")
    COLOR_ICON_DECEMBER_GRADIENT_START("--xm-color-icon-december-gradient-start"),

    @SerialName(value = "--xm-color-icon-december-gradient-end")
    COLOR_ICON_DECEMBER_GRADIENT_END("--xm-color-icon-december-gradient-end"),

    @SerialName(value = "--xm-color-font-base")
    COLOR_FONT_BASE("--xm-color-font-base"),

    @SerialName(value = "--xm-color-font-secondary")
    COLOR_FONT_SECONDARY("--xm-color-font-secondary"),

    @SerialName(value = "--xm-color-font-tertiary")
    COLOR_FONT_TERTIARY("--xm-color-font-tertiary"),

    @SerialName(value = "--xm-size-font-small")
    SIZE_FONT_SMALL("--xm-size-font-small"),

    @SerialName(value = "--xm-size-font-medium")
    SIZE_FONT_MEDIUM("--xm-size-font-medium"),

    @SerialName(value = "--xm-size-font-large")
    SIZE_FONT_LARGE("--xm-size-font-large"),

    @SerialName(value = "--xm-size-font-base")
    SIZE_FONT_BASE("--xm-size-font-base");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is MandarinTokenVar) "$data" else null

    /**
    * Returns a valid [MandarinTokenVar] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): MandarinTokenVar? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

